import { Neo } from "@singularsystems/neo-react";
import { NeoReport, Report, ReportUIRenderer, ReportUIRendererProps } from "@singularsystems/neo-reporting";
import { ReportCategory } from "../../Reports/ReportCategory";
import IFRSExposureCriteria from "./IFRSExposureCriteria";
import { ComponentType } from "react";
import { AppService, Types } from "../../../App/Services/AppService";
import { FileUtils } from "@singularsystems/neo-core";

@NeoReport("IFRSExposure", { category: ReportCategory.Exports })
export default class IFRSExposureReport extends Report<IFRSExposureCriteria> {

    constructor() {
        super(IFRSExposureCriteria);
    }

    public renderCriteria() {
        return <div>
            <Neo.GridLayout md={2}>
                <Neo.FormGroup bind={this.criteria.meta.runDate} />
            </Neo.GridLayout>
        </div>;
    }

    get uiRenderer(): ComponentType<ReportUIRendererProps> {
        return IFRSExposureReportUIRenderer;
    }
}

class IFRSExposureReportUIRenderer extends ReportUIRenderer {
    
    renderActionButtons(): React.ReactNode {
        
        return <>
            {super.renderActionButtons()}
            <Neo.Button
                icon="file"
                variant="secondary"
                onClick={() => this.downloadFile()}>
                    Download Text File
            </Neo.Button>
            <Neo.Button
                icon="file-archive"
                variant="secondary"
                onClick={() => this.downloadZipFile()}>
                    Download Zip File
            </Neo.Button>
        </>
    }

    private async downloadFile() {
        const apiClient = AppService.get(Types.Domain.ApiClients.ExportApiClient);

        const response = await this.props.taskRunner.waitFor(apiClient.getIFRSExposureFile((this.report as IFRSExposureReport).criteria.toJSObject()), {allowPost: true});

        FileUtils.showSaveFile(response);
    }

    private async downloadZipFile() {
        const apiClient = AppService.get(Types.Domain.ApiClients.ExportApiClient);

        const response = await this.props.taskRunner.waitFor(apiClient.getIFRSExposureZipFile((this.report as IFRSExposureReport).criteria.toJSObject()), {allowPost: true});

        FileUtils.showSaveFile(response);
    }
}